import { useInitialParams } from '@/app/components/hotel-detail/InitialParamsProvider';
import usePriceMode from '@/app/components/search/hooks/usePriceMode.ts';
import { useUrlSearchParams } from '../UrlSearchParamsProvider';

export default function useUserConfig() {
  const { priceType } = useInitialParams();
  const { accommodationOnly, isTrain, children, infants } = useUrlSearchParams();
  const { totalPriceMode } = usePriceMode();

  const isDoublePrice = false;
  const isDoublePriceDP =
    // config.localization.configValuesApp.doublePriceFamilyEnabled &&
    !totalPriceMode && children + infants > 0 && !isTrain && !accommodationOnly && priceType === 'PER_PERSON';

  return {
    isDoublePrice,
    isDoublePriceDP,
    showBackToTravel: true,
  };
}
